import React from 'react'
import style from './Log.module.scss'
import { ReactComponent as Review } from './img/review_icon.svg'
import { ReactComponent as Revision } from './img/revision_info.svg'
import { ReactComponent as Confirm } from './img/confirm_icon.svg'
import { dateFormat } from 'helpers/date'
import Stores from 'Stores'

const Log = ({ type, date, teacher, translate }) => {
  const renderLog = () => {
    switch (type) {
      case 'Homework Submitted':
      case 'Lesson Submitted':
        return (
          <div className={style.container}>
            <span className={style.date}>
              {dateFormat(date, 'dd MMM YYYY hh:ii')}
            </span>
            <div className={style.info}>
              <Review />
              <span>{translate.homework_checking}.</span>
            </div>
          </div>
        )
      case 'Homework Reviewed':
      case 'Lesson Reviewed':
        return (
          <div className={style.container}>
            <span className={style.date}>
              {dateFormat(date, 'dd MMM YYYY hh:ii')}
            </span>
            <div className={style.info}>
              <Revision />
              <span>
                {translate.homework_is_checked}{' '}
                <b>
                  (
                  {Stores.transliterate(
                    `${teacher.first_name} ${teacher.last_name}`,
                  )}
                  )
                </b>{' '}
                {translate.sent_for_revision}.
              </span>
            </div>
          </div>
        )
      case 'Homework Graded':
      case 'Lesson Graded':
        return (
          <div className={style.container}>
            <span className={style.date}>
              {dateFormat(date, 'dd MMM YYYY hh:ii')}
            </span>
            <div className={style.info}>
              <Confirm />
              <span>
                {translate.Homework_has_been_checked}{' '}
                <b>
                  (
                  {Stores.transliterate(
                    `${teacher.first_name} ${teacher.last_name}`,
                  )}
                  )
                </b>{' '}
                {translate.and_confirmed}.
              </span>
            </div>
          </div>
        )
      default:
        return <div>{translate.error}</div>
    }
  }

  return renderLog()
}

export default Log
